import { POPOVER_HORIZONTAL, POPOVER_VERTICAL } from '@shared/ui/popover/model/types';
import { Popover, PopoverOrigin } from '@shared/ui/popover';
import { TrashIcon, XmarkIcon } from '@shared/assets/icons';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface DeleteConfirmPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  anchorRef: React.RefObject<HTMLElement>;
  transformOrigin?: PopoverOrigin;
  className?: string;
}

export const DeleteConfirmPopup = ({
  isOpen,
  onClose,
  onConfirm,
  anchorRef,
  transformOrigin,
  className,
}: DeleteConfirmPopupProps) => {
  const contentClassName = [stylex.props(styles.content).className, className].join(' ');

  return (
    <Popover
      anchorRef={anchorRef}
      anchorOrigin={{ horizontal: POPOVER_HORIZONTAL.RIGHT, vertical: POPOVER_VERTICAL.BOTTOM }}
      transformOrigin={transformOrigin || { horizontal: POPOVER_HORIZONTAL.RIGHT, vertical: POPOVER_VERTICAL.TOP }}
      open={isOpen}
      onClose={onClose}
      preventOverflow
    >
      <div className={contentClassName}>
        <button {...stylex.props(styles.iconButton)} onClick={onConfirm} type="button">
          <TrashIcon color={colors.errorText} size="20" />
        </button>
        <button {...stylex.props(styles.textButton)} onClick={onConfirm} type="button">
          <span {...stylex.props(styles.text)}>Удалить?</span>
        </button>
        <button {...stylex.props(styles.closeButton)} onClick={onClose} type="button">
          <XmarkIcon size="24" color={colors.tertiaryIcon} />
        </button>
      </div>
    </Popover>
  );
};
